import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Location } from '@angular/common';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { ProductReportService } from 'app/infrastructure/services/productreport.service';
import { ProductReport, MappingProductReportAttribute } from 'app/infrastructure/model/classes/productReport.class';
import { TypeOptions } from 'app/infrastructure/model/interfaces/rulePrototype.interface';
import { MappingOutputAttribute } from 'app/infrastructure/model/classes/output.classes';

@Component({
    selector: 'sx-mappingList-productReport',
    templateUrl: './mappingList.productReport.component.html',
})
export class MappingListProductReportComponent implements OnInit {
    systemCode: string;
    businessCode: string;
    productCode: string;
    productReportCode: string;
    productReport: ProductReport;
    preguntarSiDeseaBorrar = [];
    mappingAttributes: MappingProductReportAttribute[] = [];

    // Opciones Tipo Dato
    opciones = TypeOptions;

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private productReportService: ProductReportService,
        private location: Location,
        private alertService: AlertService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.productCode = params['codproducto'];

            this.productReportCode = params['productReportCode'];
            this.productReport = new ProductReport();
            this.productReportService
                .get(this.productReportCode)
                .subscribe(data => {
                    if (!data) {
                        return this._router.navigateByUrl('/soc/404');
                    }
                    if (data.mappingAttributes !== undefined && data.mappingAttributes.length > 0) {
                        this.productReport = data;
                        this.mappingAttributes = data.mappingAttributes;
                    }
                });
        });
    }

    save() {
        this.productReport.mappingAttributes = this.mappingAttributes;
        this.productReportService.edit(this.productReport)
            .then(data => {
                // this.output.rulesIdByCommand = data.rulesIdByCommand;
                this.productReport = data;

                this.mappingAttributes.forEach(attribute => {
                    const result = data.mappingAttributes.find(a => a.attribute === attribute.attribute);
                });

                this.mappingAttributes = data.mappingAttributes;

                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'EDITADO_CORRECTAMENTE',
                });
            });
    }

    seleccionarOpcion(descripcionDato, tipoDato) {
        const indexMapping = this.mappingAttributes.findIndex(dato => dato.attribute === descripcionDato);
        if (indexMapping > -1) {
            this.mappingAttributes[indexMapping].type = tipoDato;
        }
    }

    clickEdit(attribute) {
        this._router.navigate(['./', attribute.id], { relativeTo: this.aRoute });
    }

    deleteAttribute(attribute: MappingOutputAttribute) {
        this.productReportService.deleteAttribute(attribute.id).
            then(x => {
                this.mappingAttributes = this.mappingAttributes.filter(a => a.id !== attribute.id);
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'OUTPUT_ATTRIUBUTE_DELETE_SUCCESS',
                });
            });
    }

    createNew() {
        this._router.navigate(['./', 'new'], { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product/productReport/mapping/mappingList.productReport.component.ts